import { ActiveEntityType, CustomSale, LineItem, RefundedLineItem } from "../../build/activeEntityType";
import { BaseLayer, BuildNode } from "../../build/types";
import { DynamicDataSectionProvider } from "../../Contexts/DynamicDataTypeContext";
import { cloneNode } from "../../utils/cloneNode";
import { renderRepeaterDiv } from "../../utils/renderRepeaterDiv";
import "./style.scss";

const SingleLineItem = ({
    lineItem,
    divElement,
    idx,
    renderProps,
    formatCurrency
}: {
    lineItem: LineItem | RefundedLineItem | CustomSale;
    divElement: any;
    idx: number;
    renderProps?: {
        layer: BaseLayer;
        node: BuildNode;
    };
    formatCurrency: (amount: number) => string;
}) => {
    return (
        <>
            <DynamicDataSectionProvider
                value={{
                    dynamicDataScope: ActiveEntityType.PRODUCT,
                    dynamicDataObject: lineItem
                }}
            >
                {renderProps ? (
                    <div className="single-line-item">
                        {renderProps.layer &&
                            renderRepeaterDiv({
                                baseLayer: renderProps.layer,
                                nodeKey: divElement.props.node.id,
                                dataObj: lineItem,
                                defaultCallback: () => {},
                                index: idx,
                                formatCurrency
                            })}
                    </div>
                ) : (
                    <div className="single-line-item" style={idx === 0 ? {} : { opacity: 0.5, pointerEvents: "none" }}>
                        {cloneNode({
                            node: divElement,
                            index: idx,
                            dataObj: lineItem,
                            keepFunctional: idx === 0
                        })}
                    </div>
                )}
            </DynamicDataSectionProvider>
        </>
    );
};

export default SingleLineItem;
